import { render, staticRenderFns } from "./MyGroupsView.vue?vue&type=template&id=3e583e91&"
import script from "./MyGroupsView.vue?vue&type=script&lang=js&"
export * from "./MyGroupsView.vue?vue&type=script&lang=js&"
import style0 from "./MyGroupsView.vue?vue&type=style&index=0&id=3e583e91&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports